// extracted by mini-css-extract-plugin
export default {"card":"DomainCard_card__vkEzJ"};